module.exports = __webpack_public_path__ + "img/bannerM.67610219.png";